import React from 'react';

import ContentButton from '../../../elements/Button/ContentButton';

const DirectoryContentLinks = props => {
    const {event, item, onOpenContentLink} = props,
        {content_links} = item;

    if (!content_links?.length) return null;

    return (
        <div className="list" style={{display: 'table', marginTop: '8px', marginBottom: '8px'}}>
            {content_links.map((contentLink, i) => (
                <ContentButton
                    key={i}
                    content={contentLink}
                    onClick={() => onOpenContentLink(contentLink)}
                    primaryColor={event.settings.primary_color}
                    secondaryColor={event.settings.secondary_color}
                />
            ))}
        </div>
    );
};

export default DirectoryContentLinks;
